
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Les différents type de site internet",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Un site internet est souvent le premier point de contact entre vous et votre audience, d’où l’importance de choisir le type de site le plus adapté à vos besoins et objectifs.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Les différents type de site internet",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Un site internet est souvent le premier point de contact entre vous et votre audience, d’où l’importance de choisir le type de site le plus adapté à vos besoins et objectifs.",
        },
      ],
    };
  },
};
